var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_2572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7205 21.8928C62.72 20.7107 62.4676 19.6662 61.9572 18.77C61.4559 17.8882 60.705 17.1493 59.6979 16.5652C51.3846 11.7637 43.0632 6.97687 34.7526 2.17049C32.512 0.874855 30.3397 0.922334 28.1158 2.23657C24.8069 4.19103 8.24006 13.6983 3.30337 16.5625C1.2703 17.7416 0.281009 19.5458 0.28052 21.8906C0.277344 31.5467 0.28052 41.2028 0.277344 50.8588C0.277344 52.015 0.519475 53.0394 1.0074 53.9222C1.50901 54.8304 2.27034 55.5896 3.30068 56.187C8.23762 59.0512 24.8066 68.5577 28.1148 70.5129C30.3397 71.8279 32.512 71.8749 34.7533 70.579C43.0642 65.7723 51.3861 60.9855 59.7006 56.1841C60.7309 55.5869 61.4923 54.8272 61.9939 53.9198C62.4811 53.0368 62.7237 52.0125 62.7237 50.8562C62.7237 50.8562 62.7237 31.5491 62.7205 21.8928Z",
    fill: "#A179DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5965 36.2808L1.00781 53.9223C1.50942 54.8306 2.27075 55.5897 3.30109 56.1871C8.23803 59.0513 24.807 68.5578 28.1152 70.513C30.3401 71.828 32.5125 71.875 34.7537 70.5791C43.0646 65.7725 51.3865 60.9857 59.701 56.1842C60.7313 55.587 61.4927 54.8274 61.9943 53.9199L31.5965 36.2808Z",
    fill: "#280068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7182 21.8929C62.7177 20.7108 62.4653 19.6662 61.9549 18.77L31.5938 36.2809L61.9916 53.9198C62.4788 53.0368 62.7209 52.0126 62.7214 50.8562C62.7214 50.8562 62.7214 31.5492 62.7182 21.8929Z",
    fill: "#390091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.602 29.6858V32.9834H52.8941V29.6858H54.5401V32.9834H57.8322V34.6322H54.5401V37.9295H57.8322V39.5783H54.5401V42.8759H52.8941V39.5783H49.602V42.8759H47.9559V39.5783H44.6641V37.9295H47.9559V34.6322H44.6641V32.9834H47.9559V29.6858H49.602ZM52.8941 34.6319H49.602V37.9295H52.8941V34.6319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6608 13.125C40.2475 13.125 47.7443 17.796 51.7599 24.7392L51.7208 24.6724L41.6177 30.4991C39.6274 27.1234 35.9786 24.8452 31.7925 24.7982L31.6606 24.7975C25.2774 24.7975 20.1025 29.981 20.1025 36.3747C20.1004 38.39 20.6261 40.3705 21.6269 42.1187C23.6192 45.6025 27.3645 47.9522 31.6608 47.9522C35.9837 47.9522 39.7503 45.5726 41.7323 42.0516L41.6842 42.1361L51.7719 47.9897C47.8003 54.8741 40.4061 59.5307 31.9193 59.6235L31.6608 59.6249C23.047 59.6249 15.5289 54.925 11.5234 47.9451C9.568 44.5377 8.44922 40.5874 8.44922 36.3747C8.44922 23.5344 18.8411 13.1248 31.6606 13.1248L31.6608 13.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_2572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 71,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.8f99da0bb543fc7fcd1306c4710bb367.svg";
export { ForwardRef as ReactComponent };